import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import CheckboxSection from "./CheckboxSection";
import useUpdateSetting from "./useUpdateSetting";

import { useFamilyRegistrationContext } from "../FamilyRegistrationContext";

CheckboxSettingSection.propTypes = {
  setting: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default function CheckboxSettingSection({
  setting,
  label,
  disabled,
  children,
}) {
  const {
    state: { familyRegistrationSettings },
  } = useFamilyRegistrationContext();

  const enabled =
    familyRegistrationSettings !== null
      ? familyRegistrationSettings[setting]?.enabled
      : false;
  // const disabled =
  //   familyRegistrationSettings !== null
  //     ? familyRegistrationSettings[setting].disabled
  //     : false;

  const [nextEnabled, setNextEnabled] = useState(enabled);

  useEffect(() => {
    if (enabled !== nextEnabled) setNextEnabled(enabled);
  }, [enabled]);

  const { updateSetting, saving, error } = useUpdateSetting();

  const handleToggle = () => {
    setNextEnabled(!enabled);
    updateSetting({ setting, value: !enabled, action: "toggle" });
  };

  // const handleStatusToggle = (membershipStatusID) => {
  //   const status = membershipStatuses.statuses.find(s => s.membershipStatusID === membershipStatusID);
  //   if (!status) return;
  //   updateSetting({ setting: "membershipStatuses", value: !status.enabled, itemID: membershipStatusID });
  // };

  useEffect(() => {
    if (error) setNextEnabled((currentVal) => !currentVal);
  }, [error]);

  const errorMessage = error && "Oops! Something went wrong :(";

  if (!setting) return null;

  return (
    <CheckboxSection
      label={label}
      enabled={nextEnabled}
      onToggle={handleToggle}
      loading={saving}
      errorMessage={errorMessage}
      disabled={disabled}
    >
      {children}
    </CheckboxSection>
  );
}
